<mat-toolbar color="primary">
    <img src="assets/img/udg_blanc_transparent_small.png" class="pre-titol-logo">
    <span i18n>Preinscripció</span>&nbsp;-&nbsp;<span>{{oferta.name}}</span>    
    <span class="pre-spacer"></span>
    <div class="button-row">
        <a mat-button href="" target="_self" style="min-width: 10px" i18n>SORTIR</a>
    </div>              
</mat-toolbar>



// WEBPACK FOOTER //
// ./src/app/header/header.component.html